export default __webpack_public_path__ + "static/media/pornhub-comment-mobile-bg.20dc9a53.png";